import provinces from "./division/province.json";
import districts from "./division/district.json";
import wards from "./division/ward.json";

export const DivisionUtils = { getProvinces, getDistricts, getWard };

function getProvinces() {
  // console.log({ provinces });
  //   return provinces.filter((province) => province.code === 1);
  return provinces;
}

function getDistricts(provinceCode: number) {
  return districts.filter((district) => district.province_code === provinceCode);
}

function getWard(districtCode: number) {
  return wards.filter((w) => w.district_code === districtCode);
}
